const shadesMap2C = {
    'light': ["F", "L"],
    'medium': ["M"],
    'deep': ["T","D"],
}

function initMenu() {
    const tabs = document.querySelectorAll('.tab');
    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            document.querySelector('.tab.active-tab')?.classList.remove('active-tab');
            tab.classList.add('active-tab');
            const tabCategories = tab.dataset.tab.split(' ');
            const tabCategoryKey = tab.dataset.tabkey;
            const swatches = Array.from(document.querySelectorAll('.clickyboxes a')).filter(Boolean);

            if (tabCategories.includes('all')) {
                swatches.forEach(swatch => {
                    swatch.parentNode.style.display = 'inline-block';
                });
                return;
            }

            swatches.forEach(swatch => {
                let isActive
                let swatchCategory = swatch.getAttribute('data-value')
                if (swatchCategory?.length <= 3) {
                    isActive = shadesMap2C[tabCategoryKey].some(category => swatchCategory.includes(category))
                } else {
                    swatchCategory = swatch.getAttribute('class')
                    isActive = tabCategories.some(tabCategory=>{
                        return  swatchCategory.toLowerCase().includes(tabCategory.toLowerCase())
                
                    });
                }

                if (isActive) {
                    swatch.parentNode.style.display = 'inline-block';
                } else {
                    swatch.parentNode.style.display = 'none';
                }
            });

        });
    });
}

// on dom load
document.addEventListener('DOMContentLoaded', () => {
    initMenu();
});